// French translations
const fr = {
  // General
  appName: 'LUCIEN14',
  loading: 'Chargement...',
  error: 'Une erreur est survenue',

  // Navigation
  nav: {
    home: 'Accueil',
    collections: 'Collections',
    culinary: 'Culinaire',
    menu: 'Menu',
    events: 'Événements',
    admin: 'Admin'
  },

  // Menu
  menu: {
    title: 'Le Menu',
    subtitle: 'Sélection de CANS NUIT',
    date: 'NOV 2025',
    footer: 'Le menu change selon les saisons, l\'inspiration et les ingrédients disponibles (MERSIN N\'A PAS TOUT — NOUS AVONS ESSAYÉ.) Options végétariennes NON disponibles sur demande.',

    // Loading stages
    loading: {
      connecting: 'Connexion au serveur...',
      fetching: 'Récupération des données du menu...',
      processing: 'Traitement des éléments du menu...',
      finalizing: 'Préparation de votre expérience...',
      ready: 'Presque prêt...',
      error: 'Erreur de connexion',
      notFound: 'Menu introuvable',
      alternative: 'Essai d\'une source alternative de menu...',
      hint: 'Notre menu vaut la peine d\'attendre. Préparation d\'un voyage culinaire juste pour vous...'
    },

    // Loading phrases
    loadingPhrases: [
      'Approvisionnement en aluminium de qualité...',
      'Consultation du sommelier...',
      'Dressage des conservateurs...',
      'Ouverture des boîtes de conserve...',
      'Organisation des ambiances...'
    ],

    // Section titles
    sections: {
      entrees: 'Les Entrées',
      plats: 'Les Plats Principaux',
      cocktails: 'Les Cocktails',
      whiskies: 'Les Whiskies',
      gins: 'Les Gins',
      vins: 'Les Vins',
      champagnes: 'Les Champagnes',
      desserts: 'Les Desserts',
      boissons: 'Les Boissons'
    },

    // Error states
    errors: {
      unavailable: 'Menu Indisponible',
      subtitle: 'Le chef a quitté le bâtiment',
      footer: 'Veuillez commander une pizza.',
      title: 'Quel Désastre!'
    }
  },

  // Footer
  footer: {
    designed: 'Conçu dans le LUCIEN14',
    rights: 'Tous droits réservés.'
  },

  // Language selector
  language: {
    select: 'Choisir la langue',
    en: 'Anglais',
    fr: 'Français',
    es: 'Espagnol',
    tr: 'Turc'
  }
};

export default fr;
